var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dt-row" },
    [
      _c(
        "div",
        {
          staticClass: "dt-row-detail",
          class:
            _vm.item.id === _vm.expandId || _vm.index % 2 == 0 ? "active" : null
        },
        [
          _c(
            "div",
            {
              staticClass: "body-col event-name",
              class: _vm.item.id != _vm.expandId ? "collapsed" : null,
              staticStyle: { width: "12%" },
              attrs: {
                block: "",
                "aria-controls": _vm.accordionId,
                "aria-expanded": _vm.item.id === _vm.expandId ? "true" : "false"
              },
              on: {
                click: function($event) {
                  _vm.setExpandId(_vm.item.id)
                  _vm.showCollapse = !_vm.showCollapse
                }
              }
            },
            [
              _c("div", { staticClass: "client-name" }, [
                _vm.viewMode != "Client"
                  ? _c("span", [_vm._v(_vm._s(_vm.item.clientName))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "name" },
                [
                  !_vm.showCollapse
                    ? _c("Icon", {
                        staticClass: "event-icon",
                        attrs: { name: "chevron-right" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showCollapse
                    ? _c("Icon", {
                        staticClass: "event-icon",
                        attrs: { name: "chevron-down" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "icon-circle" },
                    [
                      _vm.item.isChangeOrder
                        ? _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle circle-red",
                            attrs: { name: "exclamation-circle" }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.item.eventName || _vm.eventName))
                  ])
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "body-col", staticStyle: { width: "9%" } },
            [
              _c("the-mask", {
                staticClass: "data-table-row-edit-mode-text",
                attrs: {
                  mask: "##/##/####",
                  value: _vm.item.prefDate || "",
                  masked: _vm.isTrue,
                  readonly: !_vm.editable
                },
                model: {
                  value: _vm.item.prefDate,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "prefDate", $$v)
                  },
                  expression: "item.prefDate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "5%" } }, [
            _c(
              "div",
              { staticClass: "data-table-icon-circle" },
              [
                _vm.enableIconProjPart
                  ? _c("Icon", {
                      staticClass:
                        "row-detail-icon row-detail-icon-exclamation-circle",
                      attrs: { name: "exclamation-circle" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.item.projPart,
                  expression: "item.projPart"
                }
              ],
              staticClass:
                "data-table-row-edit-mode-text data-table-row-edit-mode-input-small",
              attrs: { placeholder: "100", readonly: !_vm.editable },
              domProps: { value: _vm.item.projPart },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.item, "projPart", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "body-col", staticStyle: { width: "27%" } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.item.fullAddress,
                    expression: "item.fullAddress"
                  }
                ],
                staticClass: "data-table-row-edit-mode-text",
                attrs: { placeholder: "Address", readonly: !_vm.editable },
                domProps: { value: _vm.item.fullAddress },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.item, "fullAddress", $event.target.value)
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "7%" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.item.eventLocation,
                  expression: "item.eventLocation"
                }
              ],
              staticClass: "data-table-row-edit-mode-text",
              attrs: { placeholder: "Building 3", readonly: !_vm.editable },
              domProps: { value: _vm.item.eventLocation },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.item, "eventLocation", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "7%" } }, [
            _c("span", [_vm._v(_vm._s(_vm.item.startTime))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "5%" } }, [
            _c(
              "div",
              { staticClass: "data-table-icon-circle" },
              [
                _vm.enableIconProjPart
                  ? _c("Icon", {
                      staticClass:
                        "row-detail-icon row-detail-icon-exclamation-circle",
                      attrs: { name: "exclamation-circle" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.calculateDuration))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "7%" } }, [
            _c("span", {}, [_vm._v(_vm._s(_vm.calculateTimeEnd))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "4%" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.item.timeZone,
                  expression: "item.timeZone"
                }
              ],
              staticClass: "data-table-row-edit-mode-text",
              attrs: { placeholder: "EST", readonly: !_vm.editable },
              domProps: { value: _vm.item.timeZone },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.item, "timeZone", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "9%" } }, [
            _c(
              "div",
              { staticClass: "data-table-icon-circle" },
              [
                _vm.disableIconContact
                  ? _c("Icon", {
                      staticClass:
                        "row-detail-icon row-detail-icon-exclamation-circle",
                      attrs: { name: "exclamation-circle" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.item.contactName,
                  expression: "item.contactName"
                }
              ],
              staticClass:
                "data-table-row-edit-mode-text data-table-input-contact-name",
              attrs: { placeholder: "Daniel", readonly: !_vm.editable },
              domProps: { value: _vm.item.contactName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.item, "contactName", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "8%" } }, [
            _c(
              "div",
              [_c("RowStatus", { attrs: { eventStatus: _vm.item.status } })],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          attrs: { id: _vm.accordionId, accordion: "datatable-accordion" },
          model: {
            value: _vm.showCollapse,
            callback: function($$v) {
              _vm.showCollapse = $$v
            },
            expression: "showCollapse"
          }
        },
        [
          _c("div", { staticClass: "dt-row-item-detail" }, [
            _c("div", { staticClass: "item-detail-header" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-2" }, [_vm._v("alerts")]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-7" }, [_vm._v("event notes")]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-3" }, [
                  _vm._v("on site contact")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-detail-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-3" }, [
                  _c("ul", [
                    _vm.item.projPart < 33
                      ? _c("li", [
                          _vm._v(
                            "Events under 33 participants are flagged with small site message."
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.projPart >= 200
                      ? _c("li", [
                          _vm._v(
                            "Your estimated participation is high. Break event into 2 days."
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.disableIconContact
                      ? _c("li", [
                          _vm._v(
                            "Missing email and phone number for on site contact."
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6" }, [
                  _c("div", { staticClass: "notes-field" }, [
                    _c("div", { staticClass: "text-label" }, [
                      _vm._v(
                        "\n                shipping address\n                "
                      ),
                      _c("span", { staticClass: "grey-3" }, [
                        _vm._v("(if different than event address)")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.shippingAddress,
                            expression: "item.shippingAddress"
                          }
                        ],
                        staticClass: "data-table-row-edit-mode-text",
                        attrs: {
                          placeholder: "Address",
                          readonly: !_vm.editable
                        },
                        domProps: { value: _vm.item.shippingAddress },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "shippingAddress",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "notes-field" }, [
                    _c("div", { staticClass: "text-label" }, [
                      _vm._v(
                        "\n                custom event notes\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-value" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.customEventNote,
                            expression: "item.customEventNote"
                          }
                        ],
                        staticClass: "custom-notes",
                        attrs: {
                          name: "custom-notes",
                          placeholder: "E.g. add ons, extra staff, etc",
                          readonly: !_vm.editable
                        },
                        domProps: { value: _vm.item.customEventNote },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "customEventNote",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "notes-field" }, [
                    _c("div", { staticClass: "text-label" }, [
                      _vm._v(
                        "\n                Additional comments\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-value" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.additionalComments,
                            expression: "item.additionalComments"
                          }
                        ],
                        staticClass: "additional-comments",
                        attrs: {
                          name: "additional-comments",
                          placeholder:
                            "E.g. instructions from client or change documentation",
                          readonly: !_vm.editable
                        },
                        domProps: { value: _vm.item.additionalComments },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "additionalComments",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "add-on-wrapper" }, [
                      _c("div", { staticClass: "add-on-item" }, [
                        _c("div", { staticClass: "text" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.isOnlineScheduler,
                                expression: "item.isOnlineScheduler"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "is-online-scheduler",
                              disabled: true
                            },
                            domProps: {
                              checked: Array.isArray(_vm.item.isOnlineScheduler)
                                ? _vm._i(_vm.item.isOnlineScheduler, null) > -1
                                : _vm.item.isOnlineScheduler
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.item.isOnlineScheduler,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.item,
                                        "isOnlineScheduler",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.item,
                                        "isOnlineScheduler",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.item, "isOnlineScheduler", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "is-online-scheduler" } },
                            [_vm._v("Toggle")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text title",
                            class: { active: _vm.item.isOnlineScheduler }
                          },
                          [_vm._v("Online Scheduler")]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-3" }, [
                  _c("div", { staticClass: "text-contact" }, [
                    _c("span", [_vm._v(_vm._s(_vm.item.contactName))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-contact grey-3" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.email,
                          expression: "item.email"
                        }
                      ],
                      staticClass: "phoneAndEmail",
                      attrs: {
                        placeholder: "E.g. hannah_welch@gmail.com",
                        readonly: !_vm.editable
                      },
                      domProps: { value: _vm.item.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "email", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-contact grey-3" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "func-group" })
                ])
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bb6fa2b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bb6fa2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatable/DataTableRow.vue
// module id = 1475
// module chunks = 1